

















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Ref } from 'vue-property-decorator';
import { BotProtClient } from '@/utils/botProt';
import { getQueueItHeader } from '@/utils/queue_it';

@Component
export default class BotProt extends Vue {
    widgetId: string | null = null;

    @Ref('botprot-dialog')
    dialog!: HTMLDialogElement;

    @Ref('botprot-widget')
    widgetContainer!: HTMLElement;

    @Prop({ required: true })
    shopId!: string;

    @Prop({ required: true })
    botProtClient!: BotProtClient;

    private showBotProt = false;

    async mounted() {
        const data: Record<string, unknown> = {};

        try {
            const [
                queueItKey,
                queueItValue,
            ] = await this.waitForQueueItConfig();

            switch (queueItKey) {
                case 'x-queueit-ajaxpageurl':
                    data['queueit-ajaxpageurl'] = queueItValue;
                    break;
                case 'x-queueit-cookies':
                    data['queueit-cookies'] = queueItValue;
                    break;
                default:
                    /* No-op */
                    break;
            }
        } catch (error) {
            console.warn('BotProt initialization without queue-it:', error);
        }

        this.showBotProt = await this.botProtClient.init(this.shopId, data);

        if (!this.showBotProt) {
            this.$emit('botprot-disabled');
            return false;
        }

        this.botProtClient.onChallengeComplete = (
            _verified: boolean,
            jwt: string | undefined
        ) => {
            this.$emit('verified', { jwt });

            if (this.dialog.open) {
                this.dialog.close();
            }
        };

        this.dialog.showModal();

        this.$nextTick(() => {
            let spinnerImage = this.$whitelabel.resources.spinner;
            if (this.$style.getAppliedTheme() == 'dark')
                spinnerImage = this.$whitelabel.resources.spinnerDark;

            this.botProtClient.render(
                this.widgetContainer,
                '<div><img src="' +
                    spinnerImage +
                    '" style="height: 3rem" alt="Loading"></div>'
            );
        });
    }

    /**
     * Waits for the Queue-it integration to be ready, up to a timeout
     * Needed to avoid a race condition between the Queue-it integration and the botprot init
     * @param timeoutMs
     * @param intervalMs
     */
    async waitForQueueItConfig(
        timeoutMs = 5000,
        intervalMs = 100
    ): Promise<[string, string]> {
        return new Promise((resolve, reject) => {
            const startTime = Date.now();

            const intervalId = setInterval(() => {
                const queueItValues = getQueueItHeader();
                if (queueItValues) {
                    clearInterval(intervalId);
                    resolve(queueItValues);
                } else if (Date.now() - startTime > timeoutMs) {
                    clearInterval(intervalId);
                    reject(new Error('QueueIt configuration time out'));
                }
            }, intervalMs);
        });
    }
}
